import { Star, Quote } from "lucide-react";

export default function ReviewCard({ review, index = 0 }) {
  return (
    <article
      data-testid={`review-card-${index}`}
      className="bg-white border border-border rounded-2xl p-6 sm:p-7 card-elevate relative"
    >
      <Quote size={28} className="absolute top-5 right-5 text-secondary" />
      <div className="flex items-center gap-1" aria-label="5 star rating">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} size={16} className="fill-accent text-accent" />
        ))}
      </div>
      <p className="mt-4 text-[15px] leading-relaxed text-primary/90">{review.text}</p>
      <div className="mt-5 pt-5 border-t border-border">
        <p className="font-bold text-primary">{review.name}</p>
        <p className="text-xs text-muted-foreground mt-0.5">{review.service}</p>
      </div>
    </article>
  );
}
